import { render, staticRenderFns } from "./master-themes.vue?vue&type=template&id=0ed86905"
import script from "./master-themes.vue?vue&type=script&lang=js"
export * from "./master-themes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports